import { useEffect, useRef } from "react";

// Subtle GME motion signature: a soft gold glow that trails the cursor.
// Disabled on touch devices and when the user prefers reduced motion.
export const CursorGlow = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const touch = window.matchMedia("(hover: none)").matches;
    if (reduce || touch) return;

    let tx = window.innerWidth / 2, ty = window.innerHeight / 2, x = tx, y = ty, raf;
    const move = (e) => { tx = e.clientX; ty = e.clientY; el.classList.add("on"); };
    const leave = () => el.classList.remove("on");
    const loop = () => {
      x += (tx - x) * 0.12; y += (ty - y) * 0.12;
      el.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseout", leave);
    loop();
    return () => { window.removeEventListener("mousemove", move); window.removeEventListener("mouseout", leave); cancelAnimationFrame(raf); };
  }, []);

  return <div ref={ref} className="cursor-glow" aria-hidden="true" />;
};
